import labels from "emun.cart/download-cart-images-prompt.labels";
import sizes from "emun.cart/download-cart-images-prompt.sizes";
import basicController from "servicestack/basic.controller.properties";
import $appConfig from "servicestack/config";
import ServiceBus from "servicestack/service-bus";
import httpPoller from "webutils/http-poller.service";
import { spawnUrl } from "webutils/services/util";

export default class DownloadImagesPromptController {
  constructor(options) {
    const $ctrl = this;
    console.debug("DownloadImagesPromptController", this, sizes);
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    $ctrl.title = options.title || "Download Media...";
    $ctrl.subTitle = options.subTitle;
    $ctrl.productId = options.productId;
    $ctrl.id = options.orderId || options.cartId || options.id || 0;
    $ctrl.productIds = Array.isArray(options.productIds)
      ? options.productIds
      : options.productId
      ? [options.productId]
      : [];
    $ctrl.position = options.position;
    $ctrl.sizes = sizes;
    $ctrl.labels = labels;
    $ctrl.checkedMedia = [];
    $ctrl.checkedImages = {};
    $ctrl.selected = [options.selected || sizes[1].id];
    $ctrl.includeMedia = false;
    if (options.productId) {
      $ctrl.images = [{ productId: options.productId, position: 1 }];
      $ctrl.bus.read(`QueryProductImages/${options.productId}`).then((res) => {
        res.data.results.forEach((r) => r.position > 1 && $ctrl.images.push(r));
        $ctrl.selectImages("large");
      });
      $ctrl.media = [];
      $ctrl.bus
        .read(`QueryProductMedia/${options.productId}`)
        .then((res) => ($ctrl.media = res.data.results));
    }
  }

  img({ productId, position }, size = "thumbnail") {
    const $ctrl = this;
    if (position > 1)
      return $appConfig.alternateImage(productId, position, size);
    return $appConfig.productImage(productId, size);
  }

  thumbnailUrl({ productId, position }) {
    const $ctrl = this;
    if (position > 1)
      return $appConfig.alternateImage(productId, position, "thumbnail");
    return $appConfig.productImage(productId, "thumbnail");
  }

  selectImages(size) {
    const $ctrl = this;
    $ctrl.images.forEach((m) => {
      if (!Array.isArray($ctrl.checkedImages[m.position]))
        $ctrl.checkedImages[m.position] = [size];
      else if ($ctrl.checkedImages[m.position].indexOf(size) === -1)
        $ctrl.checkedImages[m.position].push(size);
    });
  }

  getIcon({ name, fileType: type }) {
    let ext = name;
    type = type || this.contentType || ext;
    if (/(image|svg|jpg|png|gif|jpeg)/i.test(type)) return "file-image-o";
    if (/(psd)/i.test(ext)) return "picture-o";
    if (/(psd)/i.test(type)) return "picture-o";
    if (/(pdf)/i.test(type)) return "file-pdf-o";
    if (/(text|txt|log)/i.test(ext)) return "file-text-o";
    if (/(text|txt|log)/i.test(type)) return "file-text-o";
    if (/(json|html|xml)/i.test(ext)) return "file-code-o";
    if (/(json|html|xml)/i.test(type)) return "file-code-o";
    if (/(xls|csv)/i.test(ext)) return "file-excel-o";
    if (/(xls|csv)/i.test(type)) return "file-excel-o";
    if (/(doc)/i.test(ext)) return "file-word-o";
    if (/(doc)/i.test(type)) return "file-word-o";
    if (/(ppt)/i.test(ext)) return "file-powerpoint-o";
    if (/(ppt)/i.test(type)) return "file-powerpoint-o";
    if (/(mp4)/i.test(ext)) return "file-video-o";
    if (/(mp4)/i.test(type)) return "file-video-o";
    return "file-o";
  }

  submit() {
    const $ctrl = this;
    $ctrl.$notify.info(labels.generating.body, {
      title: labels.generating.heading,
      ttl: 2000,
    });
    if ($ctrl.productId) {
      // TODO: fix this, single SKU thru Lambda is not working, using urlDownloadProductMedia as a workaround
      return $ctrl.bus
        .send(
          `DownloadProductMedia/${$ctrl.productId}.json`,
          Object.keys($ctrl.checkedImages).reduce(
            (a, i) =>
              Object.assign(a, {
                ["Pos" + i]: $ctrl.checkedImages[i],
              }),
            {
              lambda: true,
              mediaIds: $ctrl.checkedMedia,
            }
          )
        )
        .then((res) => $ctrl.onSubmitted(res, `${$ctrl.productId}-MEDIA.zip`));
    } else {
      return $ctrl.bus
        .send(`DownloadOrderImages/${$ctrl.id}.json`, {
          lambda: true,
          productIds: $ctrl.productIds,
          includeMedia: $ctrl.includeMedia,
          includeAlternates: $ctrl.includeAlternates,
          position: $ctrl.position,
          sizes: $ctrl.selected.length ? $ctrl.selected : sizes,
        })
        .then((res) => $ctrl.onSubmitted(res, `${$ctrl.id}-MEDIA.zip`));
    }
  }

  onSubmitted({ data: compressBucketObjects }, fileName) {
    const $ctrl = this;
    // console.debug("compressBucketObjects", { compressBucketObjects, $ctrl });
    return httpPoller({
      url: compressBucketObjects.responseUrl,
      multiplier: 1.3,
      maxAttempts: 100,
    }).then((res) => {
      // console.debug("compressBucketObjects.zipped", res);
      if (labels.generating.done) {
        $ctrl.$notify.info(labels.generating.done);
      }
      return spawnUrl(compressBucketObjects.responseUrl, {
        fileName,
      });
    });
  }

  url() {
    const $ctrl = this;
    return $ctrl.productId
      ? $ctrl.urlDownloadProductMedia()
      : $ctrl.urlDownloadOrderImages();
  }

  urlDownloadProductMedia() {
    const $ctrl = this;
    console.info("Hi There", $ctrl.productId);
    let s = $appConfig.resolveServiceUrl(
      "DownloadProductMedia/" + $ctrl.productId + "?"
    );
    if ($ctrl.checkedMedia.length)
      s += "&MediaIds=" + $ctrl.checkedMedia.join(",");
    for (const img in $ctrl.checkedImages)
      s += "&Pos" + img + "=" + $ctrl.checkedImages[img].join(",");
    return s;
  }

  urlDownloadOrderImages() {
    const $ctrl = this;
    console.info("Hi There Again", $ctrl.id);
    let s = $appConfig.resolveServiceUrl("DownloadOrderImages?Id=" + $ctrl.id);
    if ($ctrl.productIds.length)
      s += "&ProductIds=" + $ctrl.productIds.join(",");
    if ($ctrl.includeMedia) s += "&IncludeMedia=" + $ctrl.includeMedia;
    if ($ctrl.includeAlternates)
      s += "&IncludeAlternates=" + $ctrl.includeAlternates;
    if ($ctrl.position) s += "&Position=" + $ctrl.position;
    s += "&Sizes=" + ($ctrl.selected.length ? $ctrl.selected : sizes).join(",");
    return s;
  }
}
